import {CountryModel} from './country.model';

export class RegionModel {
    constructor(public name: string, public countries: Array<CountryModel>, public checked?: boolean, public intermediate?: boolean) {
        if (checked === undefined) {
            this.checked = false;
        }

        if (intermediate === undefined) {
            this.intermediate = false;
        }
    }
}
